// extracted by mini-css-extract-plugin
module.exports = {"row":"ShelfGhostRow_row__SZJNv","slot":"ShelfGhostRow_slot__yhRhN","ghost-enter":"ShelfGhostRow_ghost-enter__6j1cw"};